import { removePushToken } from "./pushNotifications";

// Who is signed in, and what they may do.
// The backend enforces all of this; these helpers only decide what to show.
export const getUser = () => {
  try { return JSON.parse(localStorage.getItem("user") || "null"); } catch { return null; }
};

export const isStaff = (u = getUser()) => u?.role === "admin" || u?.role === "worker";
export const isAdmin = (u = getUser()) => u?.role === "admin";
export const ROLE_LABEL = { admin: "Admin", worker: "Worker", user: "Customer" };
export const homeFor = (u) => (isStaff(u) ? "/admin/dashboard" : "/quotes");

export const logoutUser = async () => {
  await removePushToken();
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};
